import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { LancamentosComponent } from './lancamentos.component';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [LancamentosComponent],
  exports: [LancamentosComponent],
  imports: [CommonModule, FormsModule, PoModule, SharedModule]
})
export class LancamentosModule {}
